export const allTransactions = {
  searchForStudentOrTransactionTitle: "Search for {{things}}",
  type: "Type",
  classAndTeacher: "Class & Teacher",
  student: "Student",
  title: "Title",
  date: "Date",
  amount: "Amount",
  typeOfTransaction: "Type of transaction",
  dateRange: "Date range",
  dateFrom: "Date from",
  dateTo: "Date to",
  resetFilters: "Reset filters",
  apply: "Apply",
  noResults: "No results",
  deleteTransaction: "Delete transaction",
  class: "Class",
  groups: "Groups",
  noGroupsInClass: "You don't have any groups added in this class",
  showGroups: "Show groups of {{name}}",
  hideGroups: "Hide groups of {{name}}",
  removeSelected: "Remove Selected",
  options: "Options",
  export: "Export",
  dataHasBeenSuccessfullyExported: "Data has been successfully exported!",
  fileIsCurrentlyBeingGenerated: "File is currently being generated",
  generateNewFile: "Generate new report",
  fileIsReady: "File {{filename}} is ready for download",
  downloadFile: "Download File",
  noTransactionRecords: "No transaction records",
  selectAllTransactions: "Select all transactions",
  selectTransaction: "Select transaction: {{title}}, {{student}}",
  actions: "Actions",
  deleteTransactionTitle: "Delete transaction \"{{title}}\"?",
  deleteThisTransaction: "Delete this transaction?",
  deleteTransactions_one: "Delete {{count}} transaction?",
  deleteTransactions_other: "Delete {{count}} transactions?",
  deleteCantBeUndone: "This can't be undone.",
  deleteIncludesAllMatching:
    "This includes all transactions matching the current filters, not only the ones loaded in the list.",
  deleteIncludesAllMatchingExceptUnticked:
    "This includes transactions matching the current filters that aren't loaded in the list, except the ones you unticked.",
  deleteConfirmWord: "DELETE",
  typeDeleteToConfirm: "Type {{word}} to confirm",
  transactionDeleted: "Transaction deleted",
  transactionsDeleted_one: "{{count}} transaction deleted",
  transactionsDeleted_other: "{{count}} transactions deleted",
  deletingTransactions_one:
    "Deleting {{count}} transaction… This can take a few minutes.",
  deletingTransactions_other:
    "Deleting {{count}} transactions… This can take a few minutes.",
  deleteTaskFailed:
    "Some transactions may not have been deleted. The list has been refreshed.",
  deleteTaskStatusUnknown:
    "We couldn't confirm the deletion status. The list has been refreshed.",
  transactionsSelected_one: "{{count}} transaction selected",
  transactionsSelected_other: "{{count}} transactions selected",
  allLoadedSelected_one: "{{formattedCount}} loaded transaction is selected.",
  allLoadedSelected_other: "All {{formattedCount}} loaded transactions are selected.",
  countingMatching: "Counting matching transactions…",
  selectAllMatching: "Select all {{total}} matching transactions",
  allMatchingSelected: "All {{total}} matching transactions are selected.",
  someMatchingSelected:
    "{{selected}} of {{total}} matching transactions are selected.",
  clearSelection: "Clear selection",
  cantSelectAll: "Can't select all",
  tooManyMatching: "More than {{limit}} transactions match these filters.",
  couldntCountRetry: "Couldn't count matching transactions. Retry",
  senderChip: "Sender: {{sender}}",
  studentStorePurchaseCantBeDeleted:
    "Student store purchases can't be deleted here",
  amountValue: "{{sign}}{{amount}}",
}
